import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

/* eslint-disable */
const member_api = 'emc-api-server.eilis-ai.com';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        uid: '',
        userName: 'Ryan',
        successMsg: '',
        comsumeMsg: '',
        exchangeMsg: '',
        pageData: {},
        userpoints: '--',
        undoMsg: '',
        lastLogin: '',
        consumeList: [],
        consumeList2: [],
        exchangeList: [],
        sendList: [],
        storeList: [],
        AllList: {},
        displayName: '無資料',
        userid: '無資料'
    },
    getters: {
        lastlogin    : state => state.lastLogin,
        successMsg   : state => state.successMsg,
        comsumeMsg   : state => state.comsumeMsg,
        exchangeMsg  : state => state.exchangeMsg,
        userpoints   : state => state.userpoints,
        undoMsg      : state => state.undoMsg,
        userid       : state => state.uid,
        username     : state => state.userName,
        displayName  : state => state.displayName,
        userid       : state => state.userid,
        consumeList  : state => state.consumeList,
        consumeList2 : state => state.consumeList2,
        sendList     : state => state.sendList,
        storeList    : state => state.storeList,
        pageData     : state => state.pageData,
        AllList      : state => state.AllList,
        exchangeList : state => state.exchangeList
    },
    mutations: {
        getUser(state, payload) {
            state.uid = payload.uid;
            state.userName = payload.displayName;
            state.lastLogin = payload.lastLoginAt;
        },
        getConsume(state, payload) {
            state.consumeList = payload.reverse();
        },
        getPoints(state, payload) {
            state.userpoints = payload;
        },
        getConsume2(state, payload) {
            state.consumeList2 = payload.reverse();
        },
        getExchange(state, payload) {
            state.exchangeList = payload.reverse();
        },
        getStoreList(state, payload) {
            state.storeList = payload;
        },
        setSuccessMsg(state, payload) {
            state.successMsg = payload;
        },
        getUserPro(state, user) {
            state.displayName = user.displayName
            state.userid = user.userid
        },
        getSendList(state, payload) {
            state.sendList = payload;
        },
        getAllList(state, payload) {
            state.AllList[payload.type] = payload.list;
        },
        getPageData(state, payload) {
            state.pageData = payload;
        }
    },
    actions: {
        // 檢查是否有開通會員
        checkAccount({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/checkAccount`;
            const postData = {
                Service: payload.Service,
                Auth: payload.Auth
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    commit('getPageData', res.data.Detail);
                    return res.data.Detail;
                });
        },
        // 檢查FB用戶
        checkUserFB({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/checkExist`;
            const postData = {
                PageID: payload.PageID,
                PSID: payload.PSID,
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    if (res.data && res.data.Detail) {
                        const point = res.data.Detail.Points ? parseInt(res.data.Detail.Points) : 0
                        commit('getPoints', point);
                    }
                    return res;
                });
        },
        // 晚點處理
        checkRecomPhone({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/checkRecomPhone`;
            const postData = {
                service: payload.service,
                auth: payload.auth,
                receivedPhone: payload.receivedPhone,
                recomPhone: payload.recomPhone,
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        setHistory({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/addHistory`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token,
                Key: payload.key,
                Store: payload.store,
                Type: payload.type,
                StoreDetail: payload.storedetail,
                UserDetail: payload.userdetail
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 檢查LINE用戶
        checkUserLINE({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/checkLine`;
            const postData = {
                ChannelID: payload.ChannelID,
                UserID: payload.UserID
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    if (res.data && res.data.Detail) {
                      const point = res.data.Detail.Points ? res.data.Detail.Points : 0
                      commit('getPoints', point);  
                    }
                    return res;
                });
        },
        // 查詢用戶點數
        getPoints({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getUserData`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Phone: payload.phone
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res.data;
                });
        },
        // 查詢用戶資料
        getUserByPhone({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getUserByPhone`;
            const postData = {
                service: payload.service,
                auth: payload.auth,
                phone: payload.phone
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res.data;
                });
        },
        // 加值點數
        refreshPointBeta({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/comsumeBeta';
            const postData = {
                Phone: payload.phone,
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token,
                Points: payload.points,
                Price: payload.price,
                Store: payload.store,
                EXP: payload.exp
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 加值點數
        refreshPoint({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/comsumeBeta';
            const postData = {
                Phone: payload.phone,
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token,
                Points: payload.points,
                Price: payload.price,
                Store: payload.store
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 登入表單
        sendSheet({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/loginHistory';
            const postData = {
                PageID: payload.auth,
                Channel: payload.service
            };
            axios.post(apiUrl, postData);
        },
        // 消費訊息
        comsumeBroadcast({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/comsumeBroadcast`;
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        },
        getRecommendDetail({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getRecommendDetail`;
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        },
        receiveRecommend({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/receiveRecommendEXP`;
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        },
        getExchange({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/getExchangeDetail';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token
            };
            axios.post(apiUrl, postData)
                .then((res) => {
                    if (res.data.List) {
                        commit('getExchange', Object.values(res.data.List));
                    } else {
                        commit('getExchange', []);
                    }
                })
        },
        // 查詢消費記錄
        getDetail({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/getConsumeDetail';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token
            };
            axios.post(apiUrl, postData)
                .then((res) => {
                    if (res.data.List) {
                        commit('getConsume', Object.values(res.data.List));
                        commit('getConsume2', Object.values(res.data.List))
                    } else {
                        commit('getConsume', []);
                        commit('getConsume2', []);
                    }
                });
        },
        // 查詢贈點紀錄
        getSend({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/getSendDetail';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token
            };
            axios.post(apiUrl, postData)
                .then((res) => {
                    if (res.data.List) {
                        commit('getSendList', Object.values(res.data.List));
                    } else {
                        commit('getSendList', []);
                    }
                })
        },
        getSendMessage({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/getSuccessMessage';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: 'Send'
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data.Message;
            })
        },
        getUnExchange({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/getSuccessMessage';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: 'UnExchange'
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data.Message;
            });
        },
        getAllHistory({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/getAllHistoryBeta';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Store: payload.store,
                Path: payload.path,
                Start: payload.start,
                End: payload.end
            };
            return axios.post(apiUrl, postData).then((res) => {
                let requestData = {};
                requestData.type = payload.path;
                requestData.list = res.data.list;
                commit('getAllList', requestData);
                return res.data.list;
            });
        },
        getRefundMessage({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/getSuccessMessage';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: 'Refund'
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data.Message;
            });
        },
        getUndoMessage({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/getSuccessMessage';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: 'Undo'
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data.Message;
            });
        },
        getStoreData({ commit, state}, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/getStoreList';
            const postData = {
                Service: payload.service,
                Auth: payload.auth
            };
            return axios.post(apiUrl, postData).then((res) => {
                if (res.data.Store) {
                    commit('getStoreList', res.data.Store);
                }
                return res;
            });
        },
        checkBindAcc({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/checkBindingAcc';
            const postData = {
                service: payload.service,
                auth: payload.auth,
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data;
            });
        },
        getExchangeMessage({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/getSuccessMessage';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: 'Exchange'
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data.Message;
            });
        },
        getComsumeMessage({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/getSuccessMessage';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: 'Comsume'
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data.Message;
            });
        },
        setSuccessMessage({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/setSuccessMessage';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: payload.type,
                Message: payload.msg
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 查詢成功訊息
        getSuccessMessage({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/getSuccessMessage';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: payload.type
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res.data.Message;
                });
        },
        // 兌換點數
        exchangePointBeta({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/exchangeBeta';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token,
                Points: payload.point,
                Store: payload.store
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 兌換點數
        exchangePoint({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/exchangeBeta';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token,
                Points: payload.point,
                Store: payload.store
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        reverseComsume({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/exchangeBeta';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token,
                Points: payload.point,
                returnExp: payload.returnExp,
                Store: payload.store,
                Undo: 'true',
                UndoType: payload.undoType,
                Employee: payload.employee,
                Key: payload.key
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        updateInfo({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/updateInfo';
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        },
        updateUser({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/updateUser';
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        },
        sendBookEvent({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/bookEvent';
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        },
        exchangeGiftCode({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/exchangeGiftCode';
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        }
    },
});

export default store;